import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchClient } from "#modules/clients/infra/fetchClient.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const clientQuery = (id: string | undefined) => ({
  queryKey: queryKeys.clients.detail(id),
  queryFn: () => fetchClient(id ?? ""),
  staleTime: STALE_TIME,
  enabled: !!id,
});
